import { computed, defineComponent, toRefs } from '@vue/composition-api';
import DpButton from '../button/Button.vue';
export default defineComponent({
    name: 'DpPaginationControl',
    components: {
        DpButton,
    },
    props: {
        currentPage: { type: Number, default: 1 },
        numberOfPages: { type: Number, default: 1 },
    },
    setup(props, { emit }) {
        const { currentPage, numberOfPages } = toRefs(props);
        const selectPage = (pageNumber) => {
            emit('select-page', pageNumber);
        };
        const previousPage = () => {
            emit('select-page', currentPage.value - 1);
        };
        const nextPage = () => {
            emit('select-page', currentPage.value + 1);
        };
        const ENDS_PADDING = 2;
        const PADDING_AROUND_CURRENT = 2;
        const paginationItems = computed(() => {
            const buttonArray = [];
            const current = currentPage.value;
            const total = numberOfPages.value;
            const startVisible = ENDS_PADDING;
            const endVisible = total - ENDS_PADDING;
            const middleVisibleStart = current - PADDING_AROUND_CURRENT;
            const middleVisibleEnd = current + PADDING_AROUND_CURRENT;
            for (let i = 1; i <= total; i += 1) {
                // Check if we include a button or break
                if (total < 6
                    || i <= startVisible || i > endVisible
                    || (i > middleVisibleStart && i < middleVisibleEnd)) {
                    buttonArray.push({
                        type: 'button',
                        pageNumber: i,
                        isActive: i === current,
                    });
                }
                else if (buttonArray[buttonArray.length - 1]?.type !== 'break') {
                    buttonArray.push({
                        type: 'break',
                        pageNumber: i,
                    });
                }
            }
            return buttonArray;
        });
        return {
            selectPage,
            paginationItems,
            nextPage,
            previousPage,
        };
    },
});
